










import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import NavBar from '@/components/NavBar.vue'

@Component({
  components: {
    NavBar
  },
  computed: {
    ...mapGetters('Auth', ['isAuthenticated'])
  },
  methods: {
    ...mapActions('Auth', ['currentSession'])
  }
})
export default class App extends Vue {
  isAuthenticated!: boolean // from the mapGetters above
  currentSession!: () => void // from the mapActions above
  env = process.env.VUE_APP_STAGE ? process.env.VUE_APP_STAGE.toUpperCase() : 'DEV'

  created () {
    if (this.isAuthenticated) {
      this.currentSession()
    }
  }
}
